<template>
<div style="text-align:left;">
  <TopNav />
  <div class="column-left">
    <SideNav />
  </div>


  <div class="column-right">
    <div class="main-container">       
      <div v-if="loaded" class="articulo-principal">
        <div style="position:absolute;  text-align: center; top:50%; left:50%; transform: translate(-50%, -50%);">
<!-- {{admin_datos}} -->
          <h2 >¡Muy buenos días {{admin_datos.nombre}}...! <img :src="admin_datos.empresa && admin_datos.empresa.atributos && admin_datos.empresa.atributos.logo_filename ? admin_datos.empresa.atributos.logo_filename : require('@/assets/logo-jobbing-nuevo.webp')" style="height:80px; z-index:100003;" alt="Imagen"></h2>
          El proposito de este panel es ayudarte en tu negocio &#128640;.  <br/> Puedes sugerir nuevas funcionalidades por <a href="https://api.whatsapp.com/send?phone=56989595796&text=¡Hola!">Whatsapp</a>.
        </div>
        

        
      </div>
      <div v-else class="articulo-principal">
        cargando...

      </div>
    </div>
  </div>



</div>
</template>

<script>
import axios from 'axios';
import {mapGetters, mapActions} from 'vuex';
import Fuse from 'fuse.js'
import SideNav from '@/components/SideNav.vue';
import TopNav from '@/components/TopNav.vue';

export default {
  name: 'HelloWorld',
  props:['id'],
  components: {
    SideNav,
    TopNav,
  },
  data() {
    return {
      loaded:true,

    }
  },
  created(){
  
  },

  methods:{
    ...mapActions(['initialize']),



  },
  computed:{
    ...mapGetters(['comunas', 'categorias', 'regiones', 'prestaciones', 'tipos', 'admin_datos']),
  },
  mounted() {
    this.fComunas = new Fuse(this.comunas, {  keys: ['Nombre']})
  },
  watch:{
    comunas_buscadas(val){
      this.resultado_fuse_comuna = this.fComunas.search(val)

    },
  }

}
</script>


<style scoped>
td{
  text-align: left;
}
.articulo-principal{



}
table
{ 
    margin-left: auto;
    margin-right: auto;
}
.column-right{
  background-color: rgb(242, 247, 251);
  padding-top:80px;
  padding-left:260px;
  width:100%;

}
.main-container{
  background-color: white;

  margin-top:10px;
  padding:20px 20px 10px 20px;
}
@media (max-width: 800px) {
 .column-right{

  padding-left:0px;


}
}
</style>

